import { isNullOrUndefined } from '@rfc/rfc-components-library/utils'
import type { OrderCreateModel } from '../types/models/OrderModel'

export const buildOrderFormData = (data: OrderCreateModel): FormData => {
    const fd = new FormData()

    if (data.id) fd.append('id', String(data.id))
    fd.append('name', data.name)
    fd.append('address', data.address)
    fd.append('customer[id]', String(data.customer.id))
    fd.append('customer[name]', data.customer.name)

    if (!isNullOrUndefined(data.comments)) fd.append('comments', data.comments)
    if (!isNullOrUndefined(data.requested_delivery_date))
        fd.append('requested_delivery_date', data.requested_delivery_date)
    if (!isNullOrUndefined(data.event_date)) fd.append('event_date', data.event_date)

    if (data.items && data.items.length > 0) {
        data.items.forEach((item, i) => {
            fd.append(`items[${i}][product][id]`, String(item.product.id))
            fd.append(`items[${i}][product][name]`, item.product.name)
            fd.append(`items[${i}][packaging]`, String(item.packaging))

            if (!isNullOrUndefined(item.timer_id)) {
                fd.append(`items[${i}][timer_id]`, String(item.timer_id))
            }
            if (!isNullOrUndefined(item.event_id)) {
                fd.append(`items[${i}][event_id]`, String(item.event_id))
            }
            if (!isNullOrUndefined(item.comments)) {
                fd.append(`items[${i}][comments]`, item.comments)
            }

            if (!isNullOrUndefined(item.csv)) {
                fd.append(`items[${i}][csv]`, item.csv)
            } else if (!isNullOrUndefined(item.data)) {
                fd.append(
                    `items[${i}][data][first_bib]`,
                    !isNullOrUndefined(item.data.first_bib) ? String(item.data.first_bib) : ''
                )
                fd.append(
                    `items[${i}][data][last_bib]`,
                    !isNullOrUndefined(item.data.last_bib) ? String(item.data.last_bib) : ''
                )
                fd.append(`items[${i}][data][text_1]`, item.data.text_1 ?? '')
                fd.append(`items[${i}][data][text_2]`, item.data.text_2 ?? '')
                fd.append(`items[${i}][data][text_3]`, item.data.text_3 ?? '')
            }

            if (!isNullOrUndefined(item.logo)) fd.append(`items[${i}][logo]`, item.logo)
        })
    }

    return fd
}
